import React, {useState, useEffect} from 'react'
import {Col, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import Moment from 'react-moment'
import * as Yup from 'yup'
import {SweetAlertWithProp} from '../../../../SweetAlertWithProp'
import {Field, Formik, Form} from 'formik'
import UserSelector from '../../../common/components/selectors/UserSelector'
import {TenantTypeIds} from '../../../common/constants/tenantTypeIds'
import {WorkOrderClient} from '../../../infrastracture/api/WorkOrderClient'
import _ from 'lodash'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {ProposalsClient} from "../../../infrastracture/api/connect/ProposalsClient";
import WorkOrderStatusSelector from "../../../common/components/selectors/WorkOrderStatusSelector";

interface Props {
    handleOk: () => void
    handleClose: () => void
    show: boolean
    workOrder: any
}

const WorkOrderMessageModal: React.FC<Props> = (props) => {
    const {handleClose, handleOk, show, workOrder} = props

    const [loading, setLoading] = useState(false)
    const [showPreview, setShowPreview] = useState(false)
    const [selectedData, setSelectedData] = useState<any>({})
    const [uploadErrors, setUploadErrors] = useState<any>([])

    const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as any

    const validationSchema = Yup.object().shape({
        // title: Yup.string().required('This field is required'),
        // message: Yup.string().required('This field is required'),
    })

    const initialState = {
        file: '',
        message: '',
        notification: true,
        email: false,
        tenantId: null,
        tenant: {} as any,
        clientUsers: null,
        contractorUsers: null,
    }

    const [initialValues, setInitialValues] = useState<any>(initialState)
    const [showSuccess, setShowSuccess] = useState(false)
    return (
        <>
            <SweetAlertWithProp
                success
                title='Success'
                onConfirm={() => {
                    handleOk()
                    setShowSuccess(false)
                }}
                confirmBtnText='Confirm'
                cancelBtnBsStyle='light'
                show={showSuccess}
                showCancel={false}
                showCloseButton
            >
                Send message success!
            </SweetAlertWithProp>
            <Modal isOpen={show} onHide={() => {
            }} zIndex={1000} size='lg'>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={async (values: any, {setStatus, setSubmitting, setFieldError}: any) => {

                        let response = await WorkOrderClient.BulkUpload(workOrder.id, values.file, values.statusId);

                        console.log('response', response);

                        if (!response.successful) {
                            if (response.data && response.data.errors) {
                                setUploadErrors(response.data.errors);
                            } else {
                                setUploadErrors(['An error occurred while processing your request.']);
                            }
                        } else if (response.successful) {
                            setUploadErrors([]);
                            setShowSuccess(true)
                        }
                    }}
                    enableReinitialize
                >
                    {({errors, touched, isSubmitting, values, setFieldValue}: any) => (
                        <>
                            <Form>
                                <ModalHeader closeButton>
                                    <h5 className='modal-title'>Message</h5>
                                </ModalHeader>
                                <ModalBody>
                                    <div className='card-body'>

                                        <div className='alert alert-danger'
                                             style={{display: uploadErrors.length > 0 ? 'block' : 'none'}}>
                                            <h4 className='alert-heading'>Errors</h4>
                                            <ul>
                                                {uploadErrors.map((error: any, index: number) => (
                                                    <li key={index}>{error}</li>
                                                ))}
                                            </ul>
                                        </div>

                                        <table className='table align-middle gs-0 gy-4'>
                                            {!loading && (
                                                <tbody>
                                                <tr>
                                                    <td colSpan={2}>
                                                        <label className='required form-label'>Bulk upload file</label>

                                                        <input type="file" className="form-control required"
                                                               id="file" name="file" onChange={async (e) => {
                                                            values.file = e.target.files?.item(0);
                                                        }}></input>

                                                    </td>
                                                    <td width='50%'>
                                                        <label className='form-label'>Initial status</label>
                                                        <WorkOrderStatusSelector
                                                            placeholder='Pricing Received Status'
                                                            defaultValue={values.status}
                                                            onChange={(name, value, label) => {
                                                                setFieldValue('status', {label, value})
                                                                setFieldValue('statusId', value)
                                                            }}
                                                            statusFlowId={workOrder.statusFlowId}
                                                        />
                                                    </td>
                                                </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <button
                                        type='button'
                                        onClick={() => {
                                            handleClose()
                                        }}
                                        className='btn btn-light'
                                    >
                                        Close
                                    </button>
                                    <button
                                        type='submit'
                                        className='btn btn-lg btn-primary'
                                        disabled={isSubmitting}
                                    >
                                        {!isSubmitting && <span className='indicator-label'>Save</span>}
                                        {isSubmitting && (
                                            <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                                        )}
                                    </button>
                                </ModalFooter>
                            </Form>
                        </>
                    )}
                </Formik>
            </Modal>
        </>
    )
}

export default WorkOrderMessageModal
